import { createSlice } from '@reduxjs/toolkit';
import type { ThemeState } from './types';

export const initialState: ThemeState = {
  name: 'dark',
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    useDarkTheme: (state) => {
      state.name = 'dark';
    },
    useLightTheme: (state) => {
      state.name = 'light';
    },
    switchTheme: (state) => {
      state.name = state.name === 'light' ? 'dark' : 'light';
    },
  },
});

export const { useDarkTheme, useLightTheme, switchTheme } = themeSlice.actions;

export default themeSlice.reducer;
